var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9525,
    height: 23.9525,
    transform: "matrix(1 0 0 -1 0.820312 24.9062)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8184 6.85938L13.7488 4.43685C13.3527 4.05187 12.4616 3.85938 11.8675 3.85938H8.10479C6.91657 3.85938 5.62934 4.72559 5.33229 5.88055L2.95586 12.9065C2.46077 14.254 3.37238 14.8594 4.85765 14.8594H8.81836C9.41247 14.8594 9.90756 15.3406 9.80854 16.0143L9.293 19.6438C9.09496 20.51 9.68907 21.4724 10.5802 21.7612C11.3724 22.0499 12.3626 21.6649 12.7586 21.0875L16.8184 14.8594",
    stroke: "#303C54",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 14,
    rx: 2,
    transform: "matrix(1 0 0 -1 16.8203 18.8594)",
    stroke: "#303C54",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.1c4d6c6012cfef9562bf988af6b95254.svg";
export { ForwardRef as ReactComponent };